import React from 'react'
import PropTypes from 'prop-types'

function HeaderIconButton({testId, children, onClick, hasUpdates}) {
  return (
    <button
      data-testid={testId}
      className={`header-icon-button${hasUpdates ? ' has-updates' : ''}`}
      type="button"
      onClick={onClick}
    >
      {children}
      {hasUpdates && <div className="update-Indicator" />}
    </button>
  )
}

HeaderIconButton.propTypes = {
  testId: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  hasUpdates: PropTypes.bool,
}

export default HeaderIconButton
